<template>
  <AbstractRouteFilters v-if="this.$store.getters.auth.isAdmin" :filters="filters" :on-click="navigate" />
</template>
<script>
import AbstractRouteFilters from './AbstractRouteFilters'

export default {
  name: 'AdministratorFilters',
  components: { AbstractRouteFilters },
  methods: {
    navigate(value) {
      this.$router.push('/administrator/' + value)
    }
  },
  computed: {
    filters() {
      return [
        { name: this.$t('filter.administratorFilters.reportedCommunities'), value: 'reportedCommunities' },
        { name: this.$t('filter.administratorFilters.reportedContent'), value: 'reportedContents' },
        { name: this.$t('filter.administratorFilters.interests'), value: 'interests' },
        { name: this.$t('filter.administratorFilters.config'), value: 'config' },
        { name: this.$t('filter.administratorFilters.anonymise'), value: 'anonymise' },
        { name: this.$t('filter.administratorFilters.testMetadatas'), value: 'testMetadatas' }
      ]
    }
  }
}
</script>
